module.exports = __webpack_public_path__ + "07d054b7570180e3a193dd5d7e5440b6.png";